export const getUserGeo = () => new Promise((resolve, reject) => {
  if (!('geolocation' in navigator)) {
    reject(new Error('Cannot get user\'s position'));
  }

  navigator.geolocation.getCurrentPosition((position) => {
    resolve(position);
  }, (error) => {
    reject(error);
  });
});

export default {
  getUserGeo,
};
